module.exports = __webpack_public_path__ + "img/randomimage (6).ae390eed.png";